__webpack_require__.p = "https://bmidxbnorwayplpreprod.netlify.app/";